import React from 'react';
import { Input, Label, TextField } from '@heroui/react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';

type LabeledTextFieldProps = {
    label: string;
    value: string;
    onChange: (value: string) => void;
    slot: string;
    placeholder?: string;
    list?: string;
};

/** Text input with a HeroUI label, matching the page's other field controls. */
export const LabeledTextField: React.FC<LabeledTextFieldProps> = ({
    label,
    value,
    onChange,
    slot,
    placeholder,
    list,
}) => (
    <TextField
        fullWidth
        onChange={onChange}
        value={value}
        {...getNodeTestIdProp(`manual-import-input-${slot}`)}
    >
        <Label
            id={`manual-import-input-label-${slot}`}
            {...getNodeTestIdProp(`manual-import-input-label-${slot}`)}
        >
            {label}
        </Label>
        <Input
            list={list}
            placeholder={placeholder}
            variant="secondary"
            {...getNodeTestIdProp(`manual-import-input-control-${slot}`)}
        />
    </TextField>
);
